/** True when playback has reached (or passed) a clip's hard-stop boundary */
export function shouldStopAtBoundary(currentSeconds: number, endBoundarySeconds: number | null): boolean {
  if (endBoundarySeconds == null) return false;
  return currentSeconds >= endBoundarySeconds;
}
